import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Settings() {
    const navigate = useNavigate();
    const [tab, setTab] = useState('profile'); // Tab active state

    return (
        <div style={styles.container}>
            <header style={styles.header}>
                <button onClick={() => navigate('/home')} style={styles.btnBack}>← Back to Dashboard</button>
                <h1 style={styles.title}>Account Settings</h1>
            </header>

            <div style={styles.layout}>
                {/* 📋 SIDEBAR MENU */}
                <aside style={styles.sidebar}>
                    <button onClick={() => setTab('profile')} style={tab === 'profile' ? styles.menuActive : styles.menuItem}>User Profile</button>
                    <button onClick={() => setTab('security')} style={tab === 'security' ? styles.menuActive : styles.menuItem}>Security & Password</button>
                    <button onClick={() => setTab('notif')} style={tab === 'notif' ? styles.menuActive : styles.menuItem}>Notifications</button>
                    <button onClick={() => navigate('/')} style={styles.btnLogout}>Logout</button>
                </aside>

                {/* 📝 CONTENT AREA */}
                <main style={styles.content}>
                    {tab === 'profile' && (
                        <section>
                            <h3 style={styles.sectionTitle}>Public Profile</h3>
                            <div style={styles.inputGroup}>
                                <label style={styles.label}>Full Name</label>
                                <input style={styles.input} defaultValue="Rony Saputra" placeholder="Enter your name" />
                            </div>
                            <div style={styles.inputGroup}>
                                <label style={styles.label}>Bio / Tagline</label>
                                <textarea style={styles.textarea} defaultValue="Fullstack Developer | Tech Enthusiast from Medan" />
                            </div>
                            <div style={styles.inputGroup}>
                                <label style={styles.label}>Location</label>
                                <input style={styles.input} defaultValue="Medan, Indonesia" />
                            </div>
                            <button style={styles.btnSave}>Save Profile</button>
                        </section>
                    )}

                    {tab === 'security' && (
                        <section>
                            <h3 style={styles.sectionTitle}>Update Password</h3>
                            <div style={styles.inputGroup}>
                                <label style={styles.label}>Current Password</label>
                                <input style={styles.input} type="password" placeholder="••••••••" />
                            </div>
                            <div style={styles.inputGroup}>
                                <label style={styles.label}>New Password</label>
                                <input style={styles.input} type="password" placeholder="Enter new password" />
                            </div>
                            <button style={styles.btnSave}>Update Password</button>
                        </section>
                    )}

                    {tab === 'notif' && (
                        <section>
                            <h3 style={styles.sectionTitle}>Email Notifications</h3>
                            <div style={styles.checkboxRow}>
                                <input type="checkbox" defaultChecked id="notif1" />
                                <label htmlFor="notif1" style={{ marginLeft: '10px' }}>New comments on my projects</label>
                            </div>
                            <div style={styles.checkboxRow}>
                                <input type="checkbox" defaultChecked id="notif2" />
                                <label htmlFor="notif2" style={{ marginLeft: '10px' }}>Weekly Nexus community newsletter</label>
                            </div>
                        </section>
                    )}
                </main>
            </div>

            {/* 📱 RESPONSIVE MOBILE */}
            <style>{`
        @media (max-width: 768px) {
          .layout-nexus { flex-direction: column !important; }
          aside { width: 100% !important; margin-bottom: 20px !important; }
        }
      `}</style>
        </div>
    );
}

const styles = {
    container: { background: '#000', color: '#fff', minHeight: '100vh', padding: '40px 20px', fontFamily: '"Inter", sans-serif' },
    header: { maxWidth: '900px', margin: '0 auto 40px', display: 'flex', alignItems: 'center', gap: '20px' },
    btnBack: { background: 'none', border: 'none', color: '#00d2ff', cursor: 'pointer', fontSize: '14px' },
    title: { fontSize: '28px', fontWeight: 'bold', margin: 0 },
    layout: { maxWidth: '900px', margin: '0 auto', display: 'flex', gap: '40px', className: 'layout-nexus' },
    sidebar: { width: '250px', display: 'flex', flexDirection: 'column', gap: '10px' },
    menuItem: { background: 'transparent', color: '#666', border: 'none', padding: '12px 20px', textAlign: 'left', borderRadius: '8px', cursor: 'pointer', transition: '0.3s' },
    menuActive: { background: '#111', color: '#00d2ff', border: 'none', padding: '12px 20px', textAlign: 'left', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' },
    btnLogout: { background: 'transparent', color: '#ff4d4d', border: '1px solid #222', padding: '12px 20px', marginTop: '20px', borderRadius: '8px', cursor: 'pointer', textAlign: 'left' },
    content: { flex: 1, background: '#070707', padding: '30px', borderRadius: '16px', border: '1px solid #111' },
    sectionTitle: { fontSize: '18px', color: '#00d2ff', marginBottom: '25px', borderBottom: '1px solid #111', paddingBottom: '10px' },
    inputGroup: { marginBottom: '20px' },
    label: { display: 'block', fontSize: '12px', color: '#444', marginBottom: '8px', fontWeight: 'bold', textTransform: 'uppercase' },
    input: { width: '100%', background: '#000', border: '1px solid #222', borderRadius: '8px', padding: '12px', color: '#fff', fontSize: '14px', outline: 'none' },
    textarea: { width: '100%', background: '#000', border: '1px solid #222', borderRadius: '8px', padding: '12px', color: '#fff', fontSize: '14px', minHeight: '80px', outline: 'none' },
    btnSave: { background: '#00d2ff', color: '#000', border: 'none', padding: '14px 25px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer', marginTop: '10px' },
    checkboxRow: { display: 'flex', alignItems: 'center', marginBottom: '15px', color: '#ccc', fontSize: '14px' }
};